<template>
  <div id="b2b">
    <section class="login">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-7 col-xs-12">
            <div class="page-login-form">
              <h3>로그인 / 회원가입</h3>

              <!-- 회원,비회원 구분 탭 -->
              <div class="lo-tap">
                <button type="button" class="member" id="pre" @click="showLogin('M')">회원(로그인)</button>
                <button type="button" class="nonmem" id="std" @click="showLogin('N')">비회원(예약확인)</button>
              </div>

              <!-- 회원 내용 -->
              <div class="minput" v-if="showFlag === 'M'">
                <div class="row">
                  <div class="form-floating">
                    <input type="text" class="form-control" id="email-id" placeholder="아이디(이메일주소)" v-model="uEmail" ref="uEmail">
                    <label for="email-id">아이디(이메일주소)</label>
                  </div>
                </div>
                <div class="row">
                  <div class="form-floating">
                    <input type="password" class="form-control" id="password" placeholder="비밀번호" v-model="uPass" ref="uPass">
                    <label for="password">비밀번호</label>
                  </div>
                </div>

                <div class="row col-12 check">
                  <div class="col-lg-12 idpw">
                    <ul>
                      <li><a href="javascript: void(0)" @click="searchMy('id')">아이디 찾기</a></li>
                      <li><a href="javascript: void(0)" @click="searchMy('pass')">비밀번호 찾기</a></li>
                      <li><a href="/membership"><strong style="color:red">회원가입</strong></a></li>
                    </ul>
                  </div>
                </div>

                <div class="row justify-content-center">
                  <div class="col-lg-12 d-grid">
                    <button type="button" class="btn go-login" ref="enterBtn" @click="memberLogin">로 그 인</button>
                  </div>
                </div>

                <hr>

                <div class="row sns">
                  <div class="row justify-content-center">
                    <div class="col-lg-12 d-grid text-start">
                      <label class="simpleBooking">
                        <span>간편 로그인</span>
                        <span class="SBexplain">
                          간편하게 회원가입과 로그인을 하실 수 있습니다.<br>
                          <font class="text-danger">※ 이름에 특수문자가 있는 경우,
                          가입처리가 되지 않을 수 있습니다</font>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-6 my-2">
                    <div id="naver_id_login"></div>
                  </div>
                  <div class="col-lg-6 my-2 kakao">
                    <button class="border" @click="kakaoLogin">
                      <img src="../assets/img/new-test/kaka.png" class="img-fluid">
                      카카오 아이디로 로그인
                    </button>
                  </div>
                </div>
              </div>

              <!-- 비회원 내용 -->
              <div class="nminput" v-else-if="showFlag === 'N'">
                <div class="row">
                  <div class="form-floating">
                    <input type="text" class="form-control" id="number" placeholder="예약번호" ref="nResCode" v-model="nResCode">
                    <label for="number">알림톡으로 안내된 예약번호</label>
                  </div>
                </div>

                <p><i class="bi bi-circle"></i> 예약번호는 카카오톡 확인 부탁드리며 확인 불가인 경우 1660-4602로 문의주시기 바랍니다.</p>

                <div class="row justify-content-center">
                  <div class="col-lg-12 d-grid">
                    <button type="button" class="btn go-reser" @click="checkNonMemRes">예약 확인</button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { genCertiNumber } from '../assets/js/AuthFunctions'
import { insPushHistory } from '../assets/js/push'

// ────────────────────────────────────────────────────────────────
// [핵심 유틸] 멤버십 만료 여부 판단
//   - 이 함수의 반환값(isActiveMember)을 store에 저장해두면
//     다른 페이지 어디서나 this.$store.state.user.isActiveMember 로
//     즉시 판단 가능. 날짜 비교를 매번 반복할 필요 없음.
// 로그인 멤버십 판정은 백엔드로 메인기능 이관 : 2026-06-05
// ────────────────────────────────────────────────────────────────
// function isMembershipActive(expDate) {
//   if (!expDate) return false
//   const today = new Date()
//   today.setHours(0, 0, 0, 0)
//   const exp = new Date(expDate)
//   exp.setHours(0, 0, 0, 0)
//   return exp >= today
// }

// 차단 계정 목록 (상수로 분리)
const BLOCKED_EMAILS = ['dnfwlq9215@nate.com']
const BLOCKED_PHONES = ['+82 10-5156-9218', '01051569218']

export default {
  data() {
    return {
      showFlag: 'M',   // 탭 플래그 (M: 회원, N: 비회원)
      uEmail:   '',    // 아이디
      uPass:    '',    // 패스워드
      nResCode: '',    // 비회원 예약번호

      // created()에서 라우터 쿼리로 세팅 - data에 선언해야 반응형 보장
      st:       '',
      pFlag:    '',
      seqReq:   '',
      pCode:    '',
      redirect: '',

      // 앱/디바이스 환경
      iosFlag:  false,
      isApp:    false,
    }
  },

  computed: {
    user() {
      return this.$store.state.user
    },
  },

  created() {
    this.st       = this.$route.query.st     || ''
    this.pFlag    = this.$route.query.pFlag  || ''
    this.seqReq   = this.$route.query.seqReq || ''
    this.pCode    = this.$route.query.pCode  || ''
    this.redirect = this.$route.query.redirect
      ? decodeURIComponent(this.$route.query.redirect)
      : ''
    this.iosFlag  = !!window.Nachocode.device.isIOS()
  },

  mounted() {
    // 네이버 로그인 SDK 초기화
    const naverLogin = new window.naver_id_login('ZWHmhzE6YbpdaPkpRVxP', 'http://ntabi.co.kr/naverCallBack')
    //let naver_id_login = new window.naver_id_login("ZWHmhzE6YbpdaPkpRVxP", "http://localhost/naverCallBack");
    naverLogin.setButton('green', 10, 62)
    naverLogin.setState(naverLogin.getUniqState())
    naverLogin.init_naver_id_login()

    this.isApp = !!window.Nachocode.env.isApp()

    document.addEventListener('keydown', this.handleEnterKeyPress)
  },

  beforeUnmount() {
    document.removeEventListener('keydown', this.handleEnterKeyPress)
  },

  methods: {

    // ────────────────────────────────────────────────────────────
    // [UI] 탭 전환
    // ────────────────────────────────────────────────────────────
    showLogin(param) {
      this.showFlag = param || 'M'
      const isMember = param === 'M'

      // 네이버 SDK는 DOM이 있어야 초기화되므로 회원 탭 전환 시 reload
      if (isMember) { location.reload(true); return }

      document.getElementById('pre').style.cssText = 'background:#fff;color:#000'
      document.getElementById('std').style.cssText = 'background:#000;color:#fff'
    },

    handleEnterKeyPress(event) 
    {
      if (event.keyCode === 13) this.memberLogin()
    },


    // ════════════════════════════════════════════════════════════
    // [LOGIN 1] 직가입 회원 로그인
    // ════════════════════════════════════════════════════════════
    async memberLogin() {
      if (!this.uEmail) 
      {
        this.$refs.uEmail.focus()
        this.$swal.fire('', '아이디(이메일)을 입력하세요', 'warning')
        return
      }
      
      if (!this.uPass) 
      {
        this.$refs.uPass.focus()
        this.$swal.fire('', '비밀번호를 입력하세요', 'warning')
        return
      }

      const loginRows = await this.$api('/api/checkMemberLogin', {
        param: [this.uEmail, this.uPass],
      })
      
      if (!loginRows.length) 
      {
        this.$swal.fire('', '아이디 또는 비밀번호를 확인해주세요.', 'error')
        location.reload(true)
        return
      }

      const info = loginRows[0]

      // loginMemberE 한 번으로 세션저장 + 멤버십조회 + 결과반환
      const sessionRes = await this.$api('/api/loginMemberE', {
        param: [{
          email   : info.uEmail,
          nickname: info.uNickName,
        }],
      })

      if (sessionRes?.result !== 'OK') 
      {
        this.$swal.fire('', '로그인 처리 중 오류가 발생했습니다.', 'error')
        return
      }

      // 서버가 계산한 membership 을 그대로 store에 저장
      const payload = this.buildStorePayload(info, sessionRes.membership)
      this.commitLogin(payload)

      await this.onLoginSuccess(info.uEmail)
      this.routeAfterLogin()
    },


    // ════════════════════════════════════════════════════════════
    // [LOGIN 2] 카카오 간편 로그인
    // ════════════════════════════════════════════════════════════
    kakaoLogin() {
      window.Kakao.Auth.login({
        scope: 'profile, account_email, gender, birthday, name, phone_number',
        success: this.getKakaoProfile,
      })
    },

    getKakaoProfile(authObj) {
      console.log('kakao authObj:', authObj)
      window.Kakao.API.request({
        url: '/v2/user/me',
        success: (res) => this.loginWithKakao(res.kakao_account),
      })
    },

    async loginWithKakao(kakaoAccount) {
      if (BLOCKED_EMAILS.includes(kakaoAccount.email) || BLOCKED_PHONES.includes(kakaoAccount.phone_number)) 
      {
        this.$swal.fire('', '당사로 문의를 주시면 감사하겠습니다.<br>1660-4602', 'warning')
        return
      }

      const phone   = this.normalizePhone(kakaoAccount.phone_number)
      const insDate = this.formatDateTime(new Date())

      const upsertParam = {
        uEmail:    kakaoAccount.email,
        uNickName: kakaoAccount.profile.nickname,
        joinFlag:  'K',
        uPhone:    phone,
        alimCallC: phone,
        uBirthday: kakaoAccount.birthday,
        uGender:   kakaoAccount.gender,
        insDate,
      }

      const res = await this.$api('/api/login', {
        param: [upsertParam, { uNickName: upsertParam.uNickName }],
      })
      if (!res?.uEmail) 
      {
        this.$swal.fire('', '로그인에 실패하였습니다', 'error')
        location.href = '/'
        return
      }

      // loginMemberE 한 번으로 세션저장 + 멤버십조회 + 결과반환
      const sessionRes = await this.$api('/api/loginMemberE', {
        param: [{
          email   : res.uEmail,
          nickname: kakaoAccount.profile.nickname,
        }],
      })
      if (sessionRes?.result !== 'OK') 
      {
        this.$swal.fire('', '로그인 처리 중 오류가 발생했습니다.', 'error')
        return
      }

      const payload = this.buildStorePayload(upsertParam, sessionRes.membership)
      this.commitLogin(payload)

      await this.onLoginSuccess_kakao(kakaoAccount.email)
      this.routeAfterLogin()
    },


    // // ════════════════════════════════════════════════════════════
    // // [공통] 멤버십 정보 조회
    // //   - 두 로그인 플로우 모두 이 메서드를 사용
    // //  로그인 멤버십 판정은 백엔드로 주요기능 이관 : 2026-06-05
    // // ════════════════════════════════════════════════════════════
    // async fetchMembershipInfo(email) {
    //   const checkRows = await this.$api('/api/checkMembershipYN', { param: [email] })
    //   if (checkRows?.[0]?.newMem !== 'Y') return {}

    //   const rows = await this.$api('/api/checkMembershipInfo_new', { param: [email] })
    //   return rows?.[0] ?? {}
    // },


    // ════════════════════════════════════════════════════════════
    // [공통] store 저장용 페이로드 생성
    //
    //   ★ isActiveMember 플래그를 여기서 확정
    //     → 다른 모든 페이지는 this.$store.state.user.isActiveMember
    //       만 보면 유료 활성 여부를 즉시 알 수 있음
    //     → router 가드, 컴포넌트 computed 어디서든 동일하게 활용
    // ════════════════════════════════════════════════════════════
    buildStorePayload(info, membership = {}) {
      return {
        email    : info.uEmail     ?? info.email,
        nickname : info.uNickName  ?? info.nickname,
        joinFlag : info.joinFlag,
        phone    : info.alimCallC  ?? info.phone,
        alimCallC: info.alimCallC,
        birthday : info.uBirthday  ?? info.birthday,
        birthyear: info.uBirthyear ?? info.birthyear,
        gender   : info.uGender    ?? info.gender,
        insDate  : info.insDate,

        // 서버가 계산해서 내려준 값 그대로 spread
        // isActiveMember, memLevel, memNo, memStaDate, memExpDate, paidFlag
        ...membership,
      }
    },


    // ════════════════════════════════════════════════════════════
    // [공통] store commit + 로컬스토리지 세션 세팅
    // ════════════════════════════════════════════════════════════
    commitLogin(payload) {
      this.$store.commit('user', payload)
      localStorage.setItem('sessionExpiration', Date.now() + 60 * 60 * 1000)
    },


    // ════════════════════════════════════════════════════════════
    // [공통] 로그인 후 라우팅 분기
    // ════════════════════════════════════════════════════════════
    routeAfterLogin() 
    {
      if (this.redirect) 
      {
        this.$router.push(this.redirect)
      } 
      else if (this.st === 'Y') 
      {
        this.$router.back()
      } 
      else if (this.st === 'M') 
      {
        this.goToReqReserveDetail(this.seqReq, this.pCode, 'Y')
      } 
      else 
      {
        this.$router.push({ path: '/' })
      }
    },

    goToReqReserveDetail(seqReq, pCode, ntCode1) {
      const route = seqReq.startsWith('RQ')
        ? { path: '/reserveInfoDetail_client', query: { seqReq, pCode, cCode: 'Y' } }
        : { path: '/eventInfo_client',         query: { eCode: seqReq, ntCd: ntCode1 } }
      this.$router.push(route)
    },


    // ════════════════════════════════════════════════════════════
    // [공통] 앱 포인트 적립 (두 플로우가 공유)
    //   - 기존에는 onLoginSuccess / onLoginSuccess_kakao 에 동일 로직
    //     중복 존재 → 이 메서드 하나로 통합
    // ════════════════════════════════════════════════════════════
    async checkAndGrantAppPoint(userId) {
      if (!this.isApp) return

      const d   = new Date()
      const ymd = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate()
      if (ymd >= 20270101) return   // 이벤트 종료

      const dup = await this.$api('/api/checkDubAppPoint', { param: [userId] })
      if (dup?.length) return   // 이미 지급된 경우

      const result = await this.$api('/api/evtPlusPoint', {
        param: [userId, 10000, '모바일앱 등록 감사포인트'],
      })
      if (!result?.affectedRows) {
        this.$swal.fire('', '포인트 적립 중 에러가 발생했습니다. 당사 웹사이트나 연락처로 문의주시면 감사하겠습니다', 'error')
        return
      }

      await this.$swal.fire({
        html: '앱다운로드 후 첫 로그인 기념으로 <span style="color:red;font-weight:600">10,000</span>포인트를 적립해 드립니다.',
        imageUrl:   '/IMGs/welcome.png',
        imageWidth:  300,
        imageHeight: 150,
        imageAlt:   'WelcomeImage',
      })
      await this.push_appPoint(userId)
    },

    // 직가입 플로우: push.registerPushToken 이 Promise 반환 안 할 수도 있어서 .then() 방식 유지
    async onLoginSuccess(userId) {
      window.Nachocode.push.registerPushToken(userId).then(async (result) => {
        if (result.status === 'success') {
          await this.checkAndGrantAppPoint(userId)
        } else {
          console.error('푸시 토큰 등록 실패:', result.message)
        }
      })
    },

    // 카카오 플로우: 순서 보장이 필요해서 await 방식
    async onLoginSuccess_kakao(userId) {
      try {
        const result = await window.Nachocode.push.registerPushToken(userId)
        if (result.status === 'success') {
          await this.checkAndGrantAppPoint(userId)
        } else {
          console.error('푸시 토큰 등록 실패:', result.message)
        }
      } catch (e) {
        console.error('푸시 토큰 등록 API 호출 중 오류:', e)
      }
    },


    // ════════════════════════════════════════════════════════════
    // [푸시] 앱 포인트 적립 알림 발송
    // ════════════════════════════════════════════════════════════
    async push_appPoint(uId) {
      const pushMessages = {
        userId:   uId,
        title:    '엔타비 첫 방문을 환영합니다',
        content:  '10,000P가 지급되었습니다. 즐거운 여행 되세요!',
        linkURL:  'https://ntabi.co.kr/',
        imageURL: 'https://ntabi.co.kr/IMGs/pushImgs/push_ntabi.png',
      }

      const result = await this.$api('api/pushSend01', { param: [{ pushMessages }] })

      const isSuccess = result === 'Push successfully requested to be sent.'
      const arr = [
        uId,
        pushMessages.title, pushMessages.content,
        pushMessages.linkURL, pushMessages.imageURL, pushMessages.userId,
        isSuccess ? '200' : '', isSuccess ? 'ok' : 'err',
        'PE', 'Y', 'Y',
      ]
      const histResult = await insPushHistory(this.$api, arr)
      console.log('푸시 히스토리:', histResult === 'Y' ? 'OK' : 'Fail')
    },


    // ════════════════════════════════════════════════════════════
    // [비회원] 예약 확인
    // ════════════════════════════════════════════════════════════
    async checkNonMemRes() {
      if (!this.nResCode) {
        this.$refs.nResCode.focus()
        this.$swal.fire('', '예약번호를 입력하세요', 'warning')
        return
      }

      const rows = await this.$api('/api/checkResNonMember_new', { param: [this.nResCode] })
      if (!rows.length) {
        this.$swal.fire(
          '',
          '카카오알림톡으로 안내된 정보를 확인해주세요<br>확인이 어려운 경우 문의처: <b class="text-danger">1660-4062</b>',
          'warning'
        )
        return
      }

      this.$router.push({
        path: '/reserveInfoDetail_nMem',
        query: {
          seqReq: this.nResCode,
          pCode:  rows[0].reqPdtCode,
          cCode:  'Y',
          rpCode: 'nonRP',
        },
      })
    },


    // ════════════════════════════════════════════════════════════
    // [아이디/비밀번호 찾기]
    // ════════════════════════════════════════════════════════════
    async searchMy(param) {
      if (param !== 'id' && param !== 'pass') {
        this.$swal.fire('', '사이트에서 직접 회원가입한 회원분만 아이디찾기가 가능합니다.', 'info')
        return
      }

      const isId = param === 'id'
      const cfg  = isId
        ? { title: '아이디찾기',    cls: 'searchId',   f1: 'alimCallC', p1: '가입시 연락처(-제외)', f2: 'uNickName', p2: '가입시 한글성명' }
        : { title: '비밀번호찾기',  cls: 'searchPass',  f1: 'alimCallC', p1: '가입시 연락처(-제외)', f2: 'uEmail',    p2: '가입시 아이디(메일주소)' }

      const { value } = await this.$swal.fire({
        html:
          `<div class="${cfg.cls}">` +
          `<b>${cfg.title}</b> <font class="fs-6">(홈페이지 가입회원만 가능)</font><br>` +
          `<input id="${cfg.f1}" class="swal2-input" placeholder="${cfg.p1}">` +
          `<input id="${cfg.f2}" class="swal2-input" placeholder="${cfg.p2}">` +
          `</div>`,
        focusConfirm: false,
        preConfirm: () => [
          document.getElementById(cfg.f1).value,
          document.getElementById(cfg.f2).value,
        ],
      })

      if (!value) {
        this.$swal.fire('', '연락처와 정보를 입력해주세요', 'warning')
        return
      }

      await this.searchMemberId(value[0], value[1], param)
    },

    async searchMemberId(phone, val, param) {
      if (param === 'id') {
        const rows = await this.$api('/api/searchMemberId', { param: [val, phone] })
        if (!rows.length) {
          this.$swal.fire('', '결과를 찾을 수 없습니다', 'warning')
          return
        }
        this.$swal.fire('', '아이디를 가입시 등록하신 연락처로 전송합니다.<br>확인해주세요.', 'info')
        this.sendKakao('CT', rows[0].uEmail, phone)
      } else {
        const rows = await this.$api('/api/searchMemberPass', { param: [val, phone] })
        if (!rows.length) {
          this.$swal.fire('', '결과를 찾을 수 없습니다', 'warning')
          return
        }
        const tempPass = await this.genCertiNumber(val)
        if (!tempPass) {
          this.$swal.fire('', '임시비밀번호 생성에 오류가 발생했습니다. 다시 비밀번호 찾기를 해주세요', 'warning')
          return
        }
        this.$swal.fire('', '임시비밀번호를 가입시 등록하신 연락처로 전송합니다.<br>확인해주세요.', 'info')
        this.sendKakao('CT', tempPass, phone)
      }
    },

    async genCertiNumber(val) {
      return genCertiNumber(this.$api, '123456789abcdefghijkmnpqrstuvwxyz', 5, val)
    },

    async sendKakao(param, cNo, mobile) {
      const res = await this.$api('/api/insKSendHistory', { param: [cNo, param, mobile] })
      if (res.affectedRows > 0 && param === 'CT') {
        this.$api('api/kakaoAlimSend4', {
          param: [{ kakaoAlimData: { certiNo: cNo, clientCall: mobile, resCode: '', alimFlag: 'CT' } }],
        }).then(console.log)
      }
    },


    // ════════════════════════════════════════════════════════════
    // [유틸] 전화번호 정규화 (+82 → 0, - 제거)
    // ════════════════════════════════════════════════════════════
    normalizePhone(rawPhone) {
      if (!rawPhone) return ''
      const p = rawPhone.startsWith('+82 ')
        ? rawPhone.replace('+82 ', '0')
        : rawPhone
      return p.replace(/-/g, '')
    },

    // ════════════════════════════════════════════════════════════
    // [유틸] 날짜 포맷 (YYYY-MM-DD HH:mm:ss)
    // ════════════════════════════════════════════════════════════
    formatDateTime(date) {
      const pad = (n) => String(n).padStart(2, '0')
      return (
        `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
        `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
      )
    },
  },
}
</script>

<!--
  ╔══════════════════════════════════════════════════════════════╗
  ║  다른 페이지에서 isActiveMember 활용 방법                      ║
  ╠══════════════════════════════════════════════════════════════╣
  ║                                                              ║
  ║  1. 컴포넌트 computed                                         ║
  ║     isActiveMember() {                                        ║
  ║       return this.$store.state.user?.isActiveMember === true  ║
  ║     }                                                         ║
  ║                                                              ║
  ║  2. 전역 mixin (main.js)                                      ║
  ║     app.mixin({                                               ║
  ║       computed: {                                             ║
  ║         $isActiveMember() {                                   ║
  ║           return this.$store.state.user?.isActiveMember===true║
  ║         }                                                     ║
  ║       }                                                       ║
  ║     })                                                        ║
  ║     → 어디서나 this.$isActiveMember 로 사용                    ║
  ║                                                              ║
  ║  3. router 가드 (router/index.js)                             ║
  ║     router.beforeEach((to, from, next) => {                   ║
  ║       const user = store.state.user                           ║
  ║       if (to.meta.requiresMembership && !user?.isActiveMember)║
  ║         next('/membership')                                   ║
  ║       else next()                                             ║
  ║     })                                                        ║
  ║                                                              ║
  ╚══════════════════════════════════════════════════════════════╝
-->

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Black+Han+Sans&family=Noto+Sans+KR:wght@400;500;600;700&display=swap');

/* ================================================
  # CSS 변수
================================================ */
#b2b {
  --ci-green:       #86cd53;
  --ci-green-dark:  #6ab53e;
  --ci-green-light: #f0faeb;
  --charcoal:       #1c1c1c;
  --text-main:      #1c1c1c;
  --text-sub:       #6b6b6b;
  --gray-100:       #f5f5f5;
  --gray-200:       #e8e8e8;
  --gray-400:       #aaaaaa;
  --off-white:      #fafaf8;
  --kakao-yellow:   #F7E600;
  --radius-sm:      8px;
  --radius-md:      16px;
  --radius-lg:      24px;
  --shadow-sm:      0 2px 12px rgba(0,0,0,0.07);
  --shadow-md:      0 8px 32px rgba(0,0,0,0.12);

  font-family: 'Noto Sans KR', sans-serif;
  background: var(--off-white);
}

#b2b .login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 4rem 0;
  background:
    radial-gradient(ellipse at 10% 20%, rgba(134,205,83,0.1) 0%, transparent 50%),
    radial-gradient(ellipse at 90% 80%, rgba(134,205,83,0.07) 0%, transparent 50%),
    var(--off-white);
}

#b2b .page-login-form {
  background: #fff;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: 2.8rem 2.5rem;
  border: 1px solid var(--gray-200);
}

#b2b .page-login-form h3 {
  font-family: 'Black Han Sans', sans-serif;
  color: var(--charcoal);
  font-size: 1.8rem;
  font-weight: 400;
  letter-spacing: 1px;
  text-align: center;
  margin-bottom: 0;
}
#b2b .page-login-form h3::after {
  content: '';
  display: block;
  width: 40px;
  height: 4px;
  background: var(--ci-green);
  border-radius: 2px;
  margin: 0.6rem auto 0;
}

@media (max-width: 991px) {
  #b2b .page-login-form { padding: 2rem 1.5rem; border-radius: var(--radius-md); }
}

#b2b .lo-tap {
  display: flex;
  margin: 2rem 0 1.8rem;
  border-radius: var(--radius-sm);
  overflow: hidden;
  border: 1.5px solid var(--gray-200);
}
#b2b .lo-tap button {
  flex: 1;
  padding: 0.9rem 0;
  background: #fff;
  border: none;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--text-sub);
  transition: all 0.25s ease;
  cursor: pointer;
}
#b2b .lo-tap button:first-child { border-right: 1.5px solid var(--gray-200); }
#b2b .lo-tap button:hover { background: var(--gray-100); }

@media (max-width: 991px) {
  #b2b .lo-tap { margin: 1.2rem 0 1.5rem; }
  #b2b .lo-tap button { padding: 0.75rem 0; font-size: 0.88rem; letter-spacing: 0.5px; }
}

#b2b .minput .form-control,
#b2b .nminput .form-control {
  border-radius: var(--radius-sm);
  border: 1.5px solid var(--gray-200);
  margin: 0.4rem 0;
  height: 3.2rem;
  font-size: 0.95rem;
  color: var(--text-main);
  transition: border-color 0.2s, box-shadow 0.2s;
}
#b2b .minput .form-control:focus,
#b2b .nminput .form-control:focus {
  border-color: var(--ci-green);
  box-shadow: 0 0 0 3px rgba(134,205,83,0.18);
}
#b2b .minput .form-floating > label,
#b2b .nminput .form-floating > label {
  padding: 1.45rem 0.9rem;
  color: var(--gray-400);
  font-size: 0.9rem;
}

#b2b .minput .check { font-size: 0.85rem; margin: 0.3rem 0 0; }
#b2b .minput .idpw ul { text-align: right; padding-left: 0; margin: 0; }
#b2b .minput .idpw ul li {
  display: inline-block;
  list-style: none;
  padding: 0 10px;
  border-right: 1px solid var(--gray-200);
  line-height: 17px;
}
#b2b .minput .idpw ul li:last-child { padding-right: 0; border-right: none; }
#b2b .minput .idpw ul li a { color: var(--text-sub); text-decoration: none; transition: color 0.2s; }
#b2b .minput .idpw ul li a:hover { color: var(--charcoal); }

@media (max-width: 991px) {
  #b2b .minput .idpw ul { text-align: center; padding-left: 0; margin-top: 1rem; }
}

#b2b .minput .go-login {
  margin: 1.2rem 0 0.5rem;
  background: var(--charcoal);
  border-radius: var(--radius-sm);
  padding: 1rem 0;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 4px;
  border: none;
  transition: all 0.25s ease;
  box-shadow: 0 4px 14px rgba(0,0,0,0.15);
}
#b2b .minput .go-login:hover {
  background: #333;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.2);
}

@media (max-width: 991px) {
  #b2b .minput .go-login { padding: 0.85rem 0; font-size: 1rem; letter-spacing: 3px; }
}

#b2b .minput hr { border-color: var(--gray-200); margin: 1.5rem 0; }

#b2b .minput .sns { text-align: center; }
#b2b .minput .simpleBooking { display: block; margin: 0 0 0.8rem; color: var(--text-main); font-size: 0.9rem; font-weight: 700; }
#b2b .minput .SBexplain { font-size: 0.78rem; color: var(--gray-400); font-weight: 400; padding-left: 8px; line-height: 1.6; }

#b2b .minput .sns #naver_id_login { display: flex; justify-content: center; }
#b2b .minput .sns #naver_id_login a,
#b2b .minput .sns #naver_id_login img {
  width: 100% !important;
  max-width: 290px !important;
  height: auto !important;
  border-radius: var(--radius-sm) !important;
}

@media (max-width: 991px) {
  #b2b .minput .sns #naver_id_login a,
  #b2b .minput .sns #naver_id_login img { max-width: 100% !important; height: 48px !important; }
}

#b2b .minput .sns .kakao { display: flex; justify-content: center; }
#b2b .minput .sns .kakao img { width: 36px; padding-right: 8px; margin-top: -2px; }
#b2b .minput .sns .kakao button {
  background: var(--kakao-yellow);
  border: none;
  width: 100%;
  max-width: 290px;
  padding: 13px 16px;
  border-radius: var(--radius-sm);
  font-size: 0.95rem;
  font-weight: 700;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.22s ease;
  box-shadow: 0 2px 8px rgba(247,230,0,0.35);
}
#b2b .minput .sns .kakao button:hover {
  background: #e6d500;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(247,230,0,0.5);
}

@media (max-width: 991px) {
  #b2b .minput .SBexplain { display: block; padding-left: 0; padding-top: 4px; margin-bottom: 12px; }
  #b2b .minput .sns .kakao button { max-width: 100%; height: 48px; padding: 0 16px; }
}

#b2b .nminput .bi { font-size: 6px; padding-right: 5px; }
#b2b .nminput p { font-size: 0.82rem; color: var(--gray-400); margin: 0.6rem 0 1rem; line-height: 1.6; }

#b2b .nminput .go-reser {
  margin: 0.5rem 0;
  background: var(--ci-green);
  border-radius: var(--radius-sm);
  padding: 1rem 0;
  color: var(--charcoal);
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 3px;
  border: none;
  transition: all 0.25s ease;
  box-shadow: 0 4px 14px rgba(134,205,83,0.35);
}
#b2b .nminput .go-reser:hover {
  background: var(--ci-green-dark);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(134,205,83,0.45);
}

@media (max-width: 991px) {
  #b2b .nminput p { font-size: 0.78rem; }
  #b2b .nminput .go-reser { padding: 0.85rem 0; font-size: 0.9rem; letter-spacing: 2px; }
}

@media (max-width: 768px) {
  .searchId, .searchPass { font-size: 0.95rem; vertical-align: middle; }
}

.form-check-input:checked { background-color: var(--ci-green); border-color: var(--ci-green); }
.form-check-input:focus { border-color: var(--ci-green); box-shadow: 0 0 0 3px rgba(134,205,83,0.2); }
</style>